/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Toast_FallbackInputs */

const en_us2_push_toast_fallback = /** @type {(inputs: Push_Toast_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New notification`)
};

const pt_br2_push_toast_fallback = /** @type {(inputs: Push_Toast_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova notificação`)
};

const es_419_push_toast_fallback = /** @type {(inputs: Push_Toast_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva notificación`)
};

const pt_pt2_push_toast_fallback = /** @type {(inputs: Push_Toast_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova notificação`)
};

const fr_fr2_push_toast_fallback = /** @type {(inputs: Push_Toast_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle notification`)
};

const de_de2_push_toast_fallback = /** @type {(inputs: Push_Toast_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Benachrichtigung`)
};

const it_it2_push_toast_fallback = /** @type {(inputs: Push_Toast_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova notifica`)
};

/**
* | output |
* | --- |
* | "New notification" |
*
* @param {Push_Toast_FallbackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_toast_fallback = /** @type {((inputs?: Push_Toast_FallbackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Toast_FallbackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_toast_fallback(inputs)
	if (locale === "es-419") return es_419_push_toast_fallback(inputs)
	if (locale === "pt-PT") return pt_pt2_push_toast_fallback(inputs)
	if (locale === "fr-FR") return fr_fr2_push_toast_fallback(inputs)
	if (locale === "de-DE") return de_de2_push_toast_fallback(inputs)
	if (locale === "it-IT") return it_it2_push_toast_fallback(inputs)
	return en_us2_push_toast_fallback(inputs)
});
export { push_toast_fallback as "push.toast_fallback" }